import { AvailableCurrency } from 'app/translations/timezones';
import { GetFunction, httpClient } from 'pkg/httpClient/httpClient';

import { mapCurrency } from './mapCurrency';

const API_URL = `https://api.db-ip.com/v2/${process.env.REACT_APP_DB_IP_KEY}/self/`;

interface CurrencyProviderApi {
  queryKey: string;
  getCurrency: () => Promise<AvailableCurrency>;
  getInitialValue: () => AvailableCurrency | undefined;
  persistSelectedCurrency: (currency: AvailableCurrency) => void;
}

interface CurrencyApiResponse {
  currencyCode: string;
}

const STORAGE_KEY = 'currency';

const currencyProviderApiFactory = (
  client: { get: GetFunction },
  storage: typeof sessionStorage
): CurrencyProviderApi => ({
  queryKey: 'userCurrency',
  getCurrency: async () => {
    const savedCurrency = storage.getItem(STORAGE_KEY) as AvailableCurrency;
    if (savedCurrency) {
      return Promise.resolve(savedCurrency);
    }
    const { currencyCode } = await client.get<CurrencyApiResponse>(API_URL, { timeout: 1000 }).then(({ data }) => data);
    return mapCurrency(currencyCode);
  },
  persistSelectedCurrency: (currency) => storage.setItem(STORAGE_KEY, currency),
  getInitialValue: () => (storage.getItem(STORAGE_KEY) as AvailableCurrency | null) ?? undefined,
});

const currencyProviderApi = currencyProviderApiFactory(httpClient, sessionStorage);

export { currencyProviderApi, currencyProviderApiFactory };
